import { markRaw, toRaw } from 'vue'
import {
  CircleCheck,
  CircleClose,
  CircleCloseFilled,
  Close,
  InfoFilled,
  Loading,
  SuccessFilled,
  WarningFilled,
} from '@zoryn/icons'
import { definePropType } from './props'

import type { Component } from 'vue'

export type IconPropType = string | Component

export const iconPropType = definePropType<string | Component>([
  String,
  Object,
  Function,
])

/** 避免 Vue 组件被 reactive 代理后作为 :is / icon 使用触发 warn */
export function resolveIconComponent(
  icon: IconPropType | undefined,
): IconPropType | undefined {
  if (!icon || typeof icon === 'string') return icon
  return markRaw(toRaw(icon)) as Component
}

function markRawIconMap<T extends Record<string, Component>>(map: T): T {
  return Object.fromEntries(
    Object.entries(map).map(([key, value]) => [key, markRaw(value)]),
  ) as T
}

export const CloseComponents = {
  Close: markRaw(Close),
}

export const TypeComponents = {
  Close: markRaw(Close),
  SuccessFilled: markRaw(SuccessFilled),
  InfoFilled: markRaw(InfoFilled),
  WarningFilled: markRaw(WarningFilled),
  CircleCloseFilled: markRaw(CircleCloseFilled),
}

export const TypeComponentsMap = markRawIconMap({
  primary: InfoFilled,
  success: SuccessFilled,
  warning: WarningFilled,
  error: CircleCloseFilled,
  info: InfoFilled,
})

export const ValidateComponentsMap = markRawIconMap({
  validating: Loading,
  success: CircleCheck,
  error: CircleClose,
})

// All icon components have the same type, so we can pick any one of them to get the type
export type IconComponent = typeof Loading
